import { render, staticRenderFns } from "./MarketingHome.vue?vue&type=template&id=c298c208&scoped=true"
import script from "./MarketingHome.vue?vue&type=script&lang=js"
export * from "./MarketingHome.vue?vue&type=script&lang=js"
import style0 from "./MarketingHome.vue?vue&type=style&index=0&id=c298c208&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c298c208",
  null
  
)

export default component.exports